/**
 *
 * Asynchronously loads the component for UnAuthorized
 *
 */

import { lazyLoad } from 'utils/loadable';

export const UnAuthorized = lazyLoad(
  () => import('./index'),
  module => module.UnAuthorized
);
